import React from 'react';
import { object, node } from 'prop-types';
import { Box } from '@mui/material';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    minHeight: 80,
    padding: 1,
  },
};

const Container = ({ children }) => <Box sx={styles.root}>{children}</Box>;

Container.propTypes = {
  classes: object.isRequired,
  children: node.isRequired,
};

export default Container;
